var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFolderEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "22px",
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFolderEditProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.49125348,21.88 L23.5087465,21.88 C24.8403343,21.88 25.92,20.792 25.92,19.4501333 L25.92,6.5392 C25.92,5.19733333 24.8403343,4.10933333 23.5087465,4.10933333 L14.007688,4.10933333 C13.6837883,4.10933333 13.3958774,4.00053333 13.1799443,3.78293333 L9.68902507,0.736533333 C9.22116992,0.301333333 8.68133705,0.12 8.10551532,0.12 L2.49125348,0.12 C1.15966574,0.12 0.08,1.208 0.08,2.54986667 L0.08,19.4501333 C0.08,20.792 1.15966574,21.88 2.49125348,21.88 Z M1.44,2.73829125 C1.44,2.02916648 2.00390244,1.46186667 2.70878049,1.46186667 L8.20682927,1.46186667 C8.52402439,1.46186667 8.80597561,1.56823538 9.01743902,1.78097281 L12.4360976,4.75929683 C12.8590244,5.14931546 13.4229268,5.32659665 13.9868293,5.32659665 L23.2912195,5.32659665 C23.9960976,5.32659665 24.56,5.89389646 24.56,6.60302123 L24.56,19.2254421 C24.56,19.9345669 23.9960976,20.5018667 23.2912195,20.5018667 L2.70878049,20.5018667 C2.00390244,20.5018667 1.44,19.9345669 1.44,19.2254421 C1.44,19.2608983 1.44,2.73829125 1.44,2.73829125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFolderEditProfile",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderEditProfile);
export default __webpack_public_path__ + "static/media/icFolderEditProfile.10f6668b6b9480cc5393c7508ae6db10.svg";
export { ForwardRef as ReactComponent };